import type { UseIntersectionObserverOptions } from '@vueuse/core'

type ComponentResolver = (component: Component) => void

export const loadWhenVisible = ({
  loader,
  as = 'div',
  loadingComponent,
  options,
  errorComponent,
  delay = 0,
  timeout
}: {
  loader: () => Promise<Component>;
  as?: string;
  loadingComponent?: any;
  options?: UseIntersectionObserverOptions;
  errorComponent?: Component;
  delay?: number;
  timeout?: number;
}) => {
  let resolveComponent: ComponentResolver = () => {}

  return defineAsyncComponent({
    loader: () => new Promise((resolve) => {
      resolveComponent = resolve as ComponentResolver
    }),
    loadingComponent: defineComponent((_, { attrs }) => {
      const target = ref()

      const { stop } = useIntersectionObserver(target, async ([{ isIntersecting }]) => {
        if (isIntersecting) {
          stop()
          resolveComponent(await loader())
        }
      }, options)

      return () => 
        h(as, {
          ref: target,
          class: attrs.class
        }, loadingComponent)
    }, {
      inheritAttrs: false
    }),
    suspensible: false,
    delay,
    errorComponent,
    timeout
  })
}